const getPrice = (amount) => `${(amount / 100).toFixed(2)} AED`;

export default getPrice;
